module.exports = __webpack_public_path__ + "img/master-img.0b16f6be.png";